var _defs, _path, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSectionSvg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:#9e19ab;}.cls-1,.cls-2{opacity:0.34;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-6{fill:#e8f7ff;}.cls-7{fill:#ddebf5;}.cls-8{fill:#3c3e40;}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:none;stroke:#9e19ab;stroke-miterlimit:10;stroke-width:2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 177.18,
    y1: 641.15,
    x2: 177.19,
    y2: 641.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#676b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#808387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#959799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#a2a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a6a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#979596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#787071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#776f70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4c4c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b3e40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 185.08,
    y1: 631.83,
    x2: 185.63,
    y2: 632.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 159.97,
    y1: 617.9,
    x2: 188.53,
    y2: 590.14,
    gradientTransform: "matrix(0.71, 0.67, -0.71, 0.67, 524.24, 134.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f8fbfd",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f1f7fb",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ebf3f9",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#e6f0f8",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e2eef6",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#dfecf6",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#deebf5",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ddebf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d9e7f1",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c9d6e0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#bbc6d0",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b0bac4",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a7b0ba",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#a0aab4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9ca5af",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#9ba4ae",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.12,359.16,519,332.74V294.82c0-.33,0-.65,0-1,.1-2.08.25-13.41-7.51-18.59L408.81,214.49A20.66,20.66,0,0,0,402.2,212a48.15,48.15,0,0,0-18.9.37,19.89,19.89,0,0,0-5.81,2.26l-97.4,56s-15,7.5-15,22.85V412s-.36,10,10.71,17.14L379.36,489.5s12.49,7.85,26.06,0L581.27,387.45a20.66,20.66,0,0,1,4.77-2c5.37-1.51,17.33-4,25.42.87l54,30.23a20.57,20.57,0,0,1,5.95,5c2.78,3.44,6.33,9.13,6.11,15.49v64.8c0,.68.12,1.35.11,2-.06,2.74.09,9.14-8.43,15.23-.41.29-.84.56-1.27.82l-56.87,34.33a20.41,20.41,0,0,1-8.63,2.88,42.59,42.59,0,0,1-17-2.2,20.71,20.71,0,0,1-3.85-1.71l-50.43-28.77a19.54,19.54,0,0,1-3.1-2.16,36.28,36.28,0,0,1-12.3-24.9,224.16,224.16,0,0,1,.71-37.13l-42.35,25.35v44.17A20.66,20.66,0,0,0,479.73,544a46.24,46.24,0,0,0,6.39,5.52c10.78,7.84,83.94,49.71,96.4,56.82a20,20,0,0,0,4.7,2c4.75,1.33,14.63,3.25,24.23-.09a20.33,20.33,0,0,0,3.54-1.65l96.45-56.32s10-5.59,13.45-16.5a19.48,19.48,0,0,0,.83-5.83L726,407.78a14.27,14.27,0,0,0-.12-3.13c-.35-2.2,0-8.9-14.66-15.8a18.91,18.91,0,0,1-1.73-.9l-97.72-57s-15.45-10.08-35.56,3.7l-1,.65L408.14,435.52a20.24,20.24,0,0,1-3.86,1.8,36,36,0,0,1-21.95.61,19.45,19.45,0,0,1-4.55-2.13L322,401a20.36,20.36,0,0,1-7.91-9,35.53,35.53,0,0,1-3-14.27c0-10.56.49-46.91.66-59.55A20.62,20.62,0,0,1,315,307.46a33.44,33.44,0,0,1,12.62-11.86L377.21,267s17.5-9.29,32.14,0l52.13,31.06a28.36,28.36,0,0,1,12.57,21.65c.05.56.07,1.13.07,1.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.2,641.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.55,631.4v.9c-.13.2-.27.39-.41.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.83,637.64a2.6,2.6,0,0,1,.43,1.34c-.26.63-.58,1.37-1,2.14-1.5,3-3.93,6.35-6.58,4.07l-.16-.14c-.22-.17-.43-.33-.66-.48a13.09,13.09,0,0,0-6.65-2A42.16,42.16,0,1,1,187,630.16a12.11,12.11,0,0,0,2.55,7.06A3.9,3.9,0,0,1,189.83,637.64Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 149.99,
    cy: 606.71,
    rx: 36.61,
    ry: 37.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 150.17,
    cy: 606.88,
    rx: 34.62,
    ry: 35.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.01,
    y: 631.36,
    width: 27.2,
    height: 55.63,
    rx: 10.07,
    transform: "translate(-406.17 337.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M177.2,641.16h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 203.53,
    y: 630.44,
    width: 10.81,
    height: 48.82,
    rx: 4,
    transform: "translate(-401.85 339.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M177.2,641.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.94,588.18s14.13-12.54,47.35-6.27c0,0-8.84-11-26.15-8.47C145.14,573.44,130.3,576,123.94,588.18Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M490.79,800.74s-6-23.52,16.81-37.71a54.45,54.45,0,0,1,9.7,7.84l22.41-.37s7.09-9.34,13.07-9.34c0,0,5.6-.37,16.43,4.86,0,0,23.52,11.57,38.08,11.57,0,0,9.71-1.12,17.55-6,0,0,21.66,7.46,20.91,32.86,0,0-19,9-21.28,17.17A17.86,17.86,0,0,1,614,835.47s-12,20.16-26.88,19.41c0,0-4.86,4.86-6.72,4.86,0,0-1.12,10.08-7.1,9,0,0-7.2.22-7-8h0s-2.67,9.11-10.51,6.5c0,0-6-.75-2.24-14.94,0,0-8,8.92-14.8,5.46,0,0-6.65-4.08.44-15.28,0,0-10.44,7.58-15.51,3.64,0,0-4.48-2,0-17C523.65,829.12,511.7,811.2,490.79,800.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M625.38,819.55s-43.67-39.81-65.79-40.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M539.71,770.5s-2.52,7.56-5.32,9c0,0-8.12,7,0,13.16,0,0,11.2,5.32,18.2-4.76,0,0,4.76-5,4.76-11.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M577.58,813.2s36.88,19.71,36.36,22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M574.15,827.35s28.17,15.4,30.19,19.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M558.47,837.29s25.11,14.89,28.66,17.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M553.52,852.27c1.17-6.49-2-9.15-2-9.15-4.66-4.2-11.85-1.3-11.85-1.3-2.52-17.46-16.06-12.7-16.06-12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M566.31,860.49s.54-12.73,7.84-11c0,0,6.91-.75,6.26,10.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M553.34,853s3-4.8,7.37-3.66c0,0,6.26,1.05,6.14,7.33"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M949,693.44H876.5c-.34-6.09,3-8.79,3-8.79h5.77l.34-19.26h9.8l10.82-12.16v-8.79h-1.7v-6.76c-27-4.74-25-60.5-25-60.5,11.49-5.06,33.2-4.38,33.2-4.38s21.72-.68,33.21,4.38c0,0,2,55.76-25,60.5v6.76h-1.69v8.79l10.82,12.16h9.79l.34,19.26H946S949.33,687.35,949,693.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M873.54,595.52s5.92.85,6.25-6.74c0,0-3.21-8.22-12.33-6.69,0,0-14.07,1.95-13.06,13.46s24.72,24.93,24.72,24.93,4.81,2.29-1.9,2.67c0,0-2.54,4.05,2.66,3.42s6.46-6,6.46-6S863.66,601.73,863.66,596c0,0-.13-5.71,7.6-6.21C871.26,589.82,878.86,589.31,873.54,595.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M952,595.52s-5.92.85-6.26-6.74c0,0,3.22-8.22,12.34-6.69,0,0,14.07,1.95,13.05,13.46s-24.71,24.93-24.71,24.93-4.81,2.29,1.9,2.67c0,0,2.54,4.05-2.66,3.42s-6.46-6-6.46-6,22.68-18.85,22.68-24.55c0,0,.13-5.71-7.6-6.21C954.23,589.82,946.63,589.31,952,595.52Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionSvg1);
export default __webpack_public_path__ + "static/media/sectionSvg1.d6a6013da67b18420498f7709bb9b9b5.svg";
export { ForwardRef as ReactComponent };